<template>
    <b-container>
        <b-row>
            <b-col></b-col>
            <b-col cols="8">
                <b-card title="Регистрация" sub-title="Завершение регистрации">
                    <b-form @submit.prevent="finishRegistration">
                        <b-form-row>
                            <b-col cols="3">
                                <b-form-group label="Имя">
                                    <b-form-input v-model="registration.firstname" readonly />
                                </b-form-group>
                            </b-col>
                            <b-col cols="4">
                                <b-form-group label="Фамилия">
                                    <b-form-input v-model="registration.lastname" readonly />
                                </b-form-group>
                            </b-col>
                            <b-col cols="5">
                                <b-form-group label="E-Mail">
                                    <b-form-input v-model="registration.email" readonly />
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <hr>
                        <b-form-group label="Логин" :feedback="feedbackUsername" :state="isValidUsername">
                            <b-form-input v-model.trim="registration.username" placeholder="Придумайте интересный логин (минимум 5 символов)" />
                        </b-form-group>
                        <b-form-row>
                            <b-col>
                                <b-form-group label="Пароль" :feedback="feedbackPassword" :state="isValidPassword">
                                    <b-form-input v-model="registration.password" type="password" placeholder="Укажите пароль" />
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="&nbsp;" feedback="<small>Введенные пароли не совпадают</small>" :state="isValidPassword2">
                                    <b-form-input v-model="registration.password2" type="password" placeholder="Повторите пароль еще раз" />
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-btn type="submit" variant="primary" :disabled="!(isValidUsername && isValidPassword && isValidPassword2) || isProcessing">Завершить</b-btn>
                    </b-form>
                </b-card>

                <b-modal title="Ошибка" v-model="isRegistrationError" :ok-only="true" class="modal-danger" >
                    <div class="my-4" v-html="registrationErrorMessage"></div>
                </b-modal>
            </b-col>
            <b-col></b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: 'confirm-registration',

        data () {
            return {
                registration: {
                    firstname: '',
                    lastname: '',
                    email: '',
                    username: '',
                    password: '',
                    password2: ''
                },

                isProcessing: false,

                isRegistrationError: false,
                registrationErrorMessage: ''
            }
        },

        computed: {
            feedbackUsername () {
                let expr = /^[a-zA-Z]+[a-zA-Z0-9-]*$/
                if (!this.registration.username.match(expr)) {
                    return '<small>Логин должен содержать только латинские буквы, цифры, символ "-" и начинаться с буквы</small>'
                }

                if (this.registration.username.length < 5) {
                    return '<small>Логин должен быть длиной минимум 5 символов</small>'
                }

                return ''
            },
            feedbackPassword () {
                let expr1 = /[!@#$%;:^&*()_+-=|\\]/
                let expr2 = /[0-9]/
                let expr3 = /[А-ЯA-Z]/

                if (!expr1.test(this.registration.password) || !expr2.test(this.registration.password) || !expr3.test(this.registration.password)) {
                    return '<small>Пароль должен содержать как минимум один специальный символ, одну цифру и одну большую букву</small>'
                }

                if (this.registration.password.length < 8) {
                    return '<small>Длина пароля должна быть не менее 8 символов</small>'
                }

                return ''
            },
            isValidUsername () {
                return this.feedbackUsername === ''
            },
            isValidPassword () {
                return this.feedbackPassword === ''
            },
            isValidPassword2 () {
                return this.registration.password === this.registration.password2
            }
        },

        mounted () {
            let token = this.$route.params['token']

            this.axios.post('auth/registration/confirmation', {
                token
            }).then(response => {
                // this.$store.dispatch('fillRegistrationData', response.data['registration_data'])
                let data = response.data['registration_data']
                this.registration.lastname = data['surname']
                this.registration.firstname = data['name']
                this.registration.email = data['email']

                this.$emit('dataLoaded')
            }).catch(error => {
                console.log(error)
            })
        },

        methods: {
            finishRegistration () {
                this.isProcessing = true
                this.axios.post('/auth/registration/finish', {
                    username: this.registration.username,
                    password: this.registration.password,
                    token: this.$route.params['token']
                }).then(response => {
                    this.$router.push({name: 'AuthLogin'})
                }).catch(error => {
                    let response = error.response.data
                    if (response.hasOwnProperty('message')) {
                        this.registrationErrorMessage = response.message
                        this.isRegistrationError = true
                    }

                    this.isProcessing = false
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Registration.vue?87aaa9de